import {connect} from 'react-redux'
import DemoDialog from "../../Components/Toolbars/TopToolbar/DemoDialog/DemoDialog";
import * as businessActions from "../actions/businessActions";

const mapStateToProps = (store) => {
    if (store.businessReducer.business.isDemo && store.businessReducer.business.dailyLimit >= 0)
        return {dailyLimit: store.businessReducer.business.dailyLimit};

    return {};
};

const mapDispatchToProps = {
    fetchBusiness: businessActions.fetchBusinessAction
};

const DemoDialogContainer = connect(mapStateToProps, mapDispatchToProps)(DemoDialog);

export default DemoDialogContainer;